import * as React from "react";

import { cs } from "@Common/react/chain-services";

import { SpecSectionFieldCreator } from "./specSectionFieldCreator";
import { CustomizationTile }          from "./customizationTile";


export const Specifications = ({idOrder, specsData, domRef, domainData, formattingModal, setUnsavedChanges, companyPrefs, maxLines, maxNumberOfLinesEnabled, branchDetails, showFormattingImageGuidelines, error}) => cs(
    ({}) =>{
        // Check if all fields have idDisplayStyle equal to 6(hidden)
    const allFieldsAreHidden = specsData.every(field => field.idDisplayStyle === 6);

    return (
      <>
        {allFieldsAreHidden ? (
          <SpecSectionFieldCreator
            idOrder={idOrder}
            data={specsData}
            domainData={domainData}
            setUnsavedChanges={setUnsavedChanges}
            companyPrefs={companyPrefs}
            branchDetails={branchDetails}
            error={error}
          />
        ) : (
          <CustomizationTile
            domRef={domRef}
            header="Specifications"
            formattingModal={formattingModal}
            xdQaName="Specifications"
            showFormattingImageGuidelines={showFormattingImageGuidelines}
          >
            <SpecSectionFieldCreator
              idOrder={idOrder}
              data={specsData}
              domainData={domainData}
              setUnsavedChanges={setUnsavedChanges}
              companyPrefs={companyPrefs}
              branchDetails={branchDetails}
              error={error}
            />
          </CustomizationTile>
        )}
      </>
    );
  }
);